// extracted by mini-css-extract-plugin
export default {"main":"WhatWeDoView_main__Rz8o+"};